function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.542 24a1.502 1.502 0 01-1.5-1.5v-21a1.502 1.502 0 011.5-1.5h13.293a1.514 1.514 0 011.064.45l3.703 3.696a1.49 1.49 0 01.44 1.061V8.5a.5.5 0 01-1 0V5.207a.497.497 0 00-.146-.353l-3.707-3.7A.507.507 0 0014.832 1H1.542a.5.5 0 00-.5.5v21a.5.5 0 00.5.5h8a.5.5 0 110 1z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.71 21H16.01a.5.5 0 010-1h1.701a.8.8 0 00.441-1.469l-1.842-1.23a1.8 1.8 0 01-.273-2.782A1.694 1.694 0 0117.312 14h1.697a.5.5 0 010 1h-1.7a.708.708 0 00-.57.23.8.8 0 00.121 1.238l1.843 1.23A1.8 1.8 0 0117.711 21z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 11.004l-.06.003a6.526 6.526 0 00-6.415 6.006c-.012.163-.025.325-.025.491 0 .177.013.352.027.526a6.497 6.497 0 106.473-7.026zm0 12a5.502 5.502 0 01-5.488-5.26c-.003-.08-.012-.159-.012-.24a5.494 5.494 0 015.247-5.487c.084-.004.167-.013.253-.013a5.5 5.5 0 010 11zM6.542 12a.5.5 0 01-.354-.146l-3-3a.502.502 0 010-.708l3-3a.5.5 0 01.708.707L4.25 8.499l2.646 2.646a.501.501 0 01-.354.855zM9.542 12a.5.5 0 01-.354-.146.494.494 0 01-.146-.354.5.5 0 01.146-.354L11.834 8.5 9.188 5.853a.5.5 0 01.708-.707l3 3a.502.502 0 010 .708l-3 3a.5.5 0 01-.354.146z"
});

function SvgConfigS(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "configS.44444.svg";
export { SvgConfigS as ReactComponent };